import { createSelector } from "@reduxjs/toolkit";
import { DesignLeftSideBarTabs } from "@multiconsult-group/multiplacer-core";
import type { IRootState } from "../app/store";
import { selectDrofusEndringerRoomGroupsQueryResult } from "../DrofusEndringer/drofusEndringerSelectors";
import { DROFUS_CHANGE_TYPE_OPTIONS } from "../components/DrofusChangeTypeFilter";

export const selectDrofusChangesPanelActive = (state: IRootState) =>
  state.design.activeLeftSideBarTab === DesignLeftSideBarTabs.DROFUS_CHANGES;

export const selectDrofusChangesRoomColorByRoomNumber = createSelector(
  selectDrofusChangesPanelActive,
  selectDrofusEndringerRoomGroupsQueryResult,
  (panelActive, result): Record<string, { fill: string; stroke: string }> => {
    if (!panelActive) return {};
    const colors: Record<string, { fill: string; stroke: string }> = {};
    for (const room of result?.data?.items ?? []) {
      const types = DROFUS_CHANGE_TYPE_OPTIONS.filter((option) =>
        option.value === "added"
          ? room.addedCount > 0
          : option.value === "removed"
            ? room.removedCount > 0
            : room.updatedCount > 0
      );
      if (!types.length || !room.roomFunctionNo) continue;
      const color = types.length > 1 ? "#1971c2" : types[0].activeBackground;
      colors[room.roomFunctionNo] = { fill: color, stroke: color };
    }
    return colors;
  }
);

export const selectDrofusChangesFilterSummary = createSelector(
  selectDrofusEndringerRoomGroupsQueryResult,
  (result) => ({
    changeCount: (result?.data?.items ?? []).reduce((total, room) => total + room.changeCount, 0),
    roomCount: result?.data?.total ?? 0,
    isLoading: !result || result.isUninitialized || result.isLoading,
    isError: result?.isError ?? false,
  })
);
